import Vue from 'vue'
import ActionCable from 'actioncable'
const WEB_SOCKET_URL = process.env.WEB_SOCKET_URL || 'ws://localhost:3000/cable'
var cable = ActionCable.createConsumer(WEB_SOCKET_URL + '?token=' + localStorage.token)
export default cable

Vue.use(ActionCable)



// WEBPACK FOOTER //
// ./src/action_cable/index.js